var _circle, _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#FFCB00"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_16809_4692)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.9316 15.9727C26.9316 16.8568 26.7311 17.6497 26.3301 18.3516C25.9382 19.0534 25.1999 19.7917 24.1152 20.5664L23.0762 21.3184C21.873 22.1751 21.2441 23.1276 21.1895 24.1758H17.5391C17.5755 23.556 17.7031 22.9818 17.9219 22.4531C18.1406 21.9245 18.4551 21.4277 18.8652 20.9629C19.2845 20.498 19.7949 20.056 20.3965 19.6367C21.0527 19.181 21.5723 18.7708 21.9551 18.4062C22.347 18.0326 22.6296 17.668 22.8027 17.3125C22.9759 16.9479 23.0625 16.556 23.0625 16.1367C23.0625 15.3346 22.7982 14.7012 22.2695 14.2363C21.75 13.7715 21.0072 13.5391 20.041 13.5391C19.1204 13.5391 18.3457 13.8079 17.7168 14.3457C17.097 14.8835 16.7324 15.5944 16.623 16.4785L12.7266 16.3145C12.9727 14.4642 13.7337 13.0241 15.0098 11.9941C16.2858 10.9642 17.9447 10.4492 19.9863 10.4492C22.1465 10.4492 23.8418 10.9414 25.0723 11.9258C26.3118 12.901 26.9316 14.25 26.9316 15.9727ZM21.3809 26.3086V30H17.4297V26.3086H21.3809Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3662 21.7256L23.3662 21.7257L23.3693 21.7234L24.4059 20.9733C24.4063 20.973 24.4067 20.9727 24.4071 20.9724C25.5155 20.1805 26.3212 19.3918 26.7654 18.5975C27.2128 17.8137 27.4316 16.9345 27.4316 15.9727C27.4316 14.1136 26.7542 12.6136 25.383 11.5341C24.0362 10.4574 22.2174 9.94922 19.9863 9.94922C17.8591 9.94922 16.0807 10.4872 14.6957 11.6051C13.306 12.7267 12.4914 14.2902 12.2309 16.2485L12.1588 16.791L12.7055 16.814L16.602 16.9781L17.0627 16.9975L17.1193 16.5399C17.2148 15.7677 17.5258 15.174 18.0431 14.7246C18.5709 14.2738 19.226 14.0391 20.041 14.0391C20.9317 14.0391 21.5384 14.2531 21.9361 14.6089L21.9361 14.609L21.9394 14.6118C22.3444 14.968 22.5625 15.4561 22.5625 16.1367C22.5625 16.4839 22.4915 16.8014 22.3522 17.0957C22.2126 17.3814 21.9729 17.6984 21.6103 18.0442C21.2529 18.3845 20.7559 18.7784 20.1113 19.226L20.1106 19.2265C19.483 19.664 18.9426 20.1306 18.4939 20.628L18.4939 20.628L18.4903 20.6321C18.0467 21.1349 17.7014 21.6782 17.4599 22.2619C17.2181 22.8463 17.0794 23.4757 17.0399 24.1464L17.0088 24.6758H17.5391H21.1895H21.664L21.6888 24.2018C21.7326 23.3611 22.2341 22.5318 23.3662 21.7256ZM21.8809 26.3086V25.8086H21.3809H17.4297H16.9297V26.3086V30V30.5H17.4297H21.3809H21.8809V30V26.3086Z",
    stroke: "white",
    strokeOpacity: 0.12
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_16809_4692",
    x: 11.5908,
    y: 9.44922,
    width: 16.3408,
    height: 22.5508,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.456094 0 0 0 0 0.526421 0 0 0 0 0.579167 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_16809_4692"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQuestion);
export default __webpack_public_path__ + "static/media/iconQuestion.834b29032be0d276ecaa2d10e63da16b.svg";
export { ForwardRef as ReactComponent };